import { Component, Input } from '@angular/core';

import { SellingCompanyReport } from '../../../models';
import { LanguageService } from '../../../services';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrl: './report-header.component.scss',
})
export class ReportHeaderComponent {
  @Input() header: string;
  @Input() model: SellingCompanyReport;

  readonly telLabel = this.languageService.translate($localize`Telephone`, 'Tel');
  readonly webLabel = this.languageService.translate($localize`Website`, 'Web');

  constructor(public languageService: LanguageService) {}
}
